import * as types from "./commonActionTypes";

const stateObject = {
  isLoading: false,
  isSuccess: false,
  payload: {},
  error: null,
  isError: false
};

const initialState = {
  metaData: { ...stateObject },
  jobList: { ...stateObject },
  npsQuestions: { ...stateObject },
  referralState: { ...stateObject },
  manageSessionState: { ...stateObject },
  jobRefreshState: { ...stateObject },
  premiumIntentState: {
    ...stateObject,
    payload: {
      banner_contact_number: null,
      banner_type: "",
      intent_image_desktop_url: "",
      intent_image_mobile_url: "",
      intent_shown: false,
      show_banner: false,
      banner_price: null
    }
  },
  queryParam: {},
  isTooltipShowing: false,
  recDeviceId: "",
  deviceType: "",
  error: null,
  isError: false,
  appLoader: false,
  captchaState: false,
  toolipConiditionsMet: {}
};

export default function commonReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_JOB_LIST_LOADING:
      return {
        ...state,
        jobList: {
          ...state.jobList,
          isLoading: true
        }
      };
    case types.GET_JOB_LIST_SUCCESS:
      return {
        ...state,
        jobList: {
          ...state.jobList,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_JOB_LIST_FAILURE:
      return {
        ...state,
        jobList: {
          ...state.jobList,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };
    case types.GET_QUERY_PARAM:
      return {
        ...state,
        getQueryParam: action.queryParam
      };

    case types.NPS_QUESTIONS_LOADING:
      return {
        ...state,
        npsQuestions: {
          ...state.npsQuestions,
          isLoading: true
        }
      };
    case types.NPS_QUESTIONS_SUCCESS:
      return {
        ...state,
        npsQuestions: {
          ...state.npsQuestions,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.NPS_QUESTIONS_FAILURE:
      return {
        ...state,
        npsQuestions: {
          ...state.npsQuestions,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };

    case types.GET_DEVICE_TYPE:
      return {
        ...state,
        deviceType: action.deviceType
      };

    case types.REFERRAL_LOADING:
      return {
        ...state,
        referralState: {
          ...state.referralState,
          isLoading: true
        }
      };
    case types.REFERRAL_SUCCESS:
      return {
        ...state,
        referralState: {
          ...state.referralState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.REFERRAL_FAILURE:
      return {
        ...state,
        referralState: {
          ...state.referralState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.MANAGE_SESSION_LOADING:
      return {
        ...state,
        manageSessionState: {
          ...state.manageSessionState,
          isLoading: true
        }
      };
    case types.MANAGE_SESSION_SUCCESS:
      return {
        ...state,
        manageSessionState: {
          ...state.manageSessionState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.MANAGE_SESSION_FAILURE:
      return {
        ...state,
        manageSessionState: {
          ...state.manageSessionState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.IS_TOOLTIP_SHOWING:
      return {
        ...state,
        isTooltipShowing: action.payload
      };
    case types.IS_APP_LOADING:
      return {
        ...state,
        appLoader: action.payload
      };
    case types.JOB_REFRESH_LOADING:
      return {
        ...state,
        jobRefreshState: {
          ...state.jobRefreshState,
          isLoading: true
        }
      };
    case types.JOB_REFRESH_SUCCESS:
      return {
        ...state,
        jobRefreshState: {
          ...state.jobRefreshState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.JOB_REFRESH_FAILURE:
      return {
        ...state,
        jobRefreshState: {
          ...state.jobRefreshState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.GET_PREMIUM_INTENT_LOADING:
      return {
        ...state,
        premiumIntentState: {
          ...stateObject,
          isLoading: true
        }
      };
    case types.GET_PREMIUM_INTENT_SUCCESS:
      return {
        ...state,
        premiumIntentState: {
          ...state.premiumIntentState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: {
            ...state.premiumIntentState.payload,
            banner_contact_number: action.payload.banner_contact_number ?? null,
            banner_type: action.payload.banner_type ?? "",
            intent_image_desktop_url:
              action.payload.intent_image_desktop_url ?? "",
            intent_image_mobile_url:
              action.payload.intent_image_mobile_url ?? "",
            intent_shown: action.payload.intent_shown ?? false,
            show_banner: action.payload.show_banner ?? false,
            banner_price: action.payload.banner_price ?? null
          }
        }
      };
    case types.GET_PREMIUM_INTENT_FAILURE:
      return {
        ...state,
        premiumIntentState: {
          ...state.premiumIntentState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.CAPTCHA_STATE:
      return {
        ...state,
        captchaState: action.payload
      };

    case types.SET_TOOLTIP_CONDITIONS_MET:
      return {
        ...state,
        toolipConiditionsMet: {
          ...state.toolipConiditionsMet,
          ...action.payload
        }
      };

    default:
      return state;
  }
}
